import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a1400] py-12 px-4" data-id="element-266">
      <div className="max-w-5xl mx-auto" data-id="element-267">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-268">
          <div data-id="element-269">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-270">
              +500
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-271">
              profes confían
            </div>
          </div>
          <div data-id="element-272">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-273">
              6+6
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-274">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-275">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-276">
              4.9/5
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-277">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-278">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-279">🇦🇷</div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-280">
              Todo el país
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-281">
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-282">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-283">
              SM
            </div>
            <div data-id="element-284">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-285">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-286">
                "Compré un domingo. El lunes tenía todo el año organizado."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-287">
                — Sebastián M., Buenos Aires | Profesor de Teatro en Primaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-288">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-289">
              CR
            </div>
            <div data-id="element-290">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-291">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-292">
                "Las rúbricas del Bono 3 me cambiaron todo. Evalúo con criterios
                claros en cada clase."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-293">
                — Claudia R., Rosario | Profesora en Secundaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-294">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-295">
              DP
            </div>
            <div data-id="element-296">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-297">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-298">
                "El Tomo 4 es único. Mis alumnos de 1ro trabajan con subtexto
                real desde el primer mes."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-299">
                — Diego P., Córdoba | Tallerista de Teatro
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}